import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import CustomHeaderButton from "../components/CustomHeaderButton";
import CartIcon from "../contexts/Cart/CartIcon";
import { useNavigate } from "react-router-dom";
import LoginDashboardDrawer from "../components/LoginDashboardDrawer";
interface Props {
  onClose: () => void;
  open: boolean;
}

const Sidebar = ({ open, onClose }: Props): JSX.Element => {
  const aboutUSUrl = "/about-us";
  const contactUsUrl = "/contact-us";
  const faqURL = "/faq";
  const theme = useTheme();
  const navigate = useNavigate();

  const handleNavigation = (url: string) => {
    navigate(url);
  };

  return (
    <>
      <Drawer
        anchor="left"
        onClose={onClose}
        open={open}
        variant="temporary"
        PaperProps={{
          sx: {
            backgroundColor: theme.palette.background.default,
            width: 256,
          },
        }}
      >
        <Box height="100%">
          <Box width={1}>
            <IconButton
              size="large"
              onClick={() => handleNavigation("/")}
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                opacity: 0.5,
                "&:hover": {
                  opacity: 0.8,
                },
              }}
            >
              <img
                src="/images/MamFamLogo.png"
                alt="logo"
                style={{ maxWidth: "70%" }}
              />
              <Box sx={{ display: { md: "inline", xs: "none" } }}>
                <Typography
                  variant="h6"
                  sx={{
                    flexGrow: 1,
                    color: theme.palette.text.primary,
                    fontWeight: "bold",
                    textDecoration: "none",
                    marginLeft: "10px",
                  }}
                >
                  Make A Memory Family
                </Typography>
              </Box>
            </IconButton>
          </Box>
          <Box padding={2}>
            <Box paddingY={2}>
              <CustomHeaderButton
                navigationLink="/"
                text="Home Page"
                onClose={() => onClose()}
              />
            </Box>
            <Box paddingY={2}>
              <CustomHeaderButton
                navigationLink={aboutUSUrl}
                text="About Us"
                onClose={() => onClose()}
              />
            </Box>
            <Box paddingY={2}>
              <CustomHeaderButton
                navigationLink={contactUsUrl}
                text="Contact Us"
                onClose={() => onClose()}
              />
            </Box>
            <Box paddingY={2}>
              <CustomHeaderButton
                navigationLink={faqURL}
                text="FAQs"
                onClose={() => onClose()}
              />
            </Box>
            <Box paddingY={2}>
              <LoginDashboardDrawer onClose={() => onClose()} />
            </Box>

            <CartIcon />
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
